import React from "react";
import { TrendingUp, TrendingDown, Trash2, Compass } from "lucide-react";

const STYLES = {
  BUY: {
    Icon: TrendingUp,
    card: "from-emerald-500/10 border-emerald-500/30",
    glow: "bg-emerald-500/10",
    pill: "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
    circle: "bg-emerald-500/10 text-emerald-400",
    text: "text-emerald-400",
  },
  SELL: {
    Icon: TrendingDown,
    card: "from-red-500/10 border-red-500/30",
    glow: "bg-red-500/10",
    pill: "bg-red-500/15 text-red-400 border-red-500/20",
    circle: "bg-red-500/10 text-red-400",
    text: "text-red-400",
  },
};

export const BiasCard = ({ b, admin, onDelete, onOpen }) => {
  const dir = (b.direction || "BUY").toUpperCase();
  const s = STYLES[dir] || STYLES.BUY;
  const Icon = s.Icon;
  return (
    <div
      data-testid={`bias-card-${b.id}`}
      onClick={() => onOpen && onOpen(b)}
      className={`bg-gradient-to-br to-[#141414] border rounded-md p-5 relative overflow-hidden flex flex-col cursor-pointer transition-transform hover:-translate-y-0.5 ${s.card}`}
    >
      <div className={`absolute top-0 right-0 w-32 h-32 blur-3xl rounded-full pointer-events-none ${s.glow}`} />
      <div className="relative flex flex-col h-full">
        <div className="flex items-center justify-between gap-2 mb-3">
          <span className={`inline-flex items-center gap-1.5 text-[11px] font-mono px-2 py-0.5 rounded-full border ${s.pill}`}>
            <Compass size={12} /> GENERAL BIAS
          </span>
          {admin && (
            <button
              data-testid={`delete-bias-${b.id}`}
              onClick={(e) => { e.stopPropagation(); onDelete && onDelete(b.id); }}
              className="p-1.5 rounded-md text-zinc-500 hover:text-red-400 hover:bg-red-500/10 transition-colors"
              title="Elimina bias"
            >
              <Trash2 size={15} />
            </button>
          )}
        </div>
        <div className="flex items-center gap-3">
          <div className={`shrink-0 w-11 h-11 rounded-full flex items-center justify-center ${s.circle}`}>
            <Icon size={22} />
          </div>
          <div>
            <div className={`text-xl font-bold tracking-tight ${s.text}`} data-testid={`bias-direction-${b.id}`}>
              GENERAL BIAS: {dir}
            </div>
            <div className="text-sm text-zinc-300 mt-0.5 font-medium">
              {b.symbol} <span className="text-zinc-500">·</span> {b.timeframe}
            </div>
          </div>
        </div>
        <p className="text-xs text-zinc-500 mt-3 leading-relaxed">
          Entrambe le strategie (Liquidity Pool + Stoch Trend) hanno dato un segnale {dir} consecutivo su questo strumento e timeframe: bias direzionale del prezzo.
        </p>
        <div className="text-[11px] text-zinc-600 mt-4 font-mono">
          {b.created_at && new Date(b.created_at).toLocaleString("it-IT", { timeZone: "Europe/Rome" })}
        </div>
      </div>
    </div>
  );
};
